@file:OptIn(InternalResourceApi::class)

package com.flowyride.feature.planner.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.flowyride.feature.planner.resources/"

@delegate:ResourceContentHash(-1_417_991_508)
internal val Res.plurals.speed_cameras_on_route: PluralStringResource by lazy {
      PluralStringResource("plurals:speed_cameras_on_route", "speed_cameras_on_route", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 126),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("speed_cameras_on_route", Res.plurals.speed_cameras_on_route)
}
